module.exports = __webpack_public_path__ + "media/images/athletes/1306-97e9d890c58dd5518cb54cc2a0c6e369.png";